var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-box"},[_c('h5',{staticClass:"article_title"},[_vm._v("注册协议")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"article_content",domProps:{"innerHTML":_vm._s(_vm.data)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1ca1d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpagreement.vue
// module id = null
// module chunks = 